import Raven from 'raven-js';

export const PostCheckoutModalComponent = {
    bindings: {
        isAuthenticated: '<',
        checkGuid: '<',
        customer: '<',
        deliveryInfo: '<',
        isDelivery: '<',
        loyaltyAccountAttached: '<',
        orderData: '<',
        restaurantGuid: '<',
        restaurantName: '<'
    },

    template: `
        <modal c-modal="post-checkout-modal" open="$ctrl.isOpen">
            <modal-header>
                <ikon ng-click="$ctrl.close()" ikon="times"></ikon>
            </modal-header>
            <modal-content>
                <div class="flex-row centered-row seperated-row">
                    <h1>
                        {{$ctrl.getHeader()}}
                    </h1>
                </div>
                <div class="flex-row centered-row separated-row">
                    {{$ctrl.getMessage()}}
                </div>
                <div class="flex-row centered-row" ng-if="!$ctrl.isAuthenticated">
                    {{$ctrl.getCreateAccountMessage()}}
                </div>
                <oo-alert ng-if="$ctrl.errorMessage && $ctrl.isAuthenticated" severity="error">
                    <oo-alert-message>{{$ctrl.errorMessage}}</oo-alert-message>
                </oo-alert>
                <div class="flex-row centered-row separated-row" ng-if="$ctrl.isAuthenticated">
                    <oo-button
                        is-loading="$ctrl.signupLoading"
                        is-disabled="$ctrl.signupDisabled"
                        id="button-signup-loyalty"
                        types="button button-primary"
                        button-type="button"
                        button-click="$ctrl.onLoyaltySignup()"
                        >Join Now!</oo-button>
                </div>

                <div ng-if="!$ctrl.isAuthenticated">
                    <ca-create-account on-success="$ctrl.createAccountSuccessCallback()"
                                        on-error="$ctrl.createAccountErrorCallback(errorMessage)"
                                        restaurant-name="$ctrl.restaurantName"
                                        restaurant-guid="$ctrl.restaurantGuid"
                                        after-checkout="true"
                                        customer="$ctrl.customer"
                                        is-delivery="$ctrl.isDelivery"
                                        delivery-info="$ctrl.deliveryInfo"
                                        check-guid="$ctrl.checkGuid"
                                        order-data="$ctrl.orderData"
                                        should-create-loyalty-account="!$ctrl.loyaltyAccountAttached"
                                        use-narrow-mode="true"
                    ></ca-create-account>
                </div>
            </modal-content>
        </modal>
    `,

    controller: class PostCheckoutModalController {
        constructor(
            calloutService,
            googleAnalyticsTrackingService,
            loyaltyService
        ) {
            'ngInject';

            Object.assign(this, {
                calloutService,
                googleAnalyticsTrackingService,
                loyaltyService
            });

            this.signupLoading = false;
            this.signupDisabled = false;
        }

        $onInit() {
            this.loyaltyService.getConfig()
                .then(config => {
                    this.loyaltyConfig = config;
                    if (this.shouldOpen()) {
                        this.open();
                    }
                });
        }

        open() {
            this.isOpen = true;
        }

        close() {
            this.isOpen = false;
        }

        onLoyaltySignup() {
            this.signupLoading = true;
            this.loyaltyService.signUp(this.cart)
                .then(
                    () => {
                        this.close();
                        this.calloutService.info('Successfully joined rewards!');
                    },
                    error => {
                        Raven.captureMessage('onLoyaltySignup() failed', {
                            level: 'error',
                            extra: { error }
                        });
                        this.errorMessage = 'A problem occurred, please try again.';
                    }
                )
                .finally(() => {
                    this.signupLoading = false;
                });
        }

        createAccountSuccessCallback() {
            this.close();
            this.signupLoading = false;
            this.googleAnalyticsTrackingService.trackCreateAccountSuccess();
            this.calloutService.info(`A confirmation email has been sent to ${this.customer.email}. Please verify your email before signing in to access your information.`);
        }

        createAccountErrorCallback(errorMessage) {
            this.googleAnalyticsTrackingService.trackCreateAccountError(errorMessage);
            this.signupLoading = false;
        }

        shouldOpen() {
            return this.loyaltyConfig.signupAllowed && !(this.isAuthenticated && this.loyaltyAccountAttached);
        }

        getHeader() {
            if (this.loyaltyConfig.signupBonus && this.loyaltyConfig.signupBonus > 0) {
                return `Start earning rewards today, plus earn ${this.loyaltyConfig.signupBonus} bonus points!`;
            }
            return 'Start earning points today!';
        }

        getMessage() {
            return 'Earn rewards for every dollar spent, in store and online.';
        }

        getCreateAccountMessage() {
            return 'By creating an account, you\'ll earn rewards and securely save payment information. A confirmation email will be sent.';
        }
    }
};
